import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./context/AuthProvider";
import { LanguageProvider } from "./context/LanguageContext";
import { UserDataProvider } from "./context/UserDataContext";
import { SettingsProvider } from "./context/SettingsContext";
import { CompanyConfigProvider } from "./context/CompanyConfigContext";
import { CompanyThemeProvider } from "./context/CompanyThemeContext";
import { BrandProvider } from "./context/BrandContext";
import { ClientPreferencesProvider } from "./context/ClientPreferencesContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrandProvider>
    <AuthProvider>
      <ClientPreferencesProvider>
        <LanguageProvider>
          <CompanyConfigProvider env="production">
            <CompanyThemeProvider>
              <UserDataProvider>
                <SettingsProvider>
                  <App />
                  <ToastContainer
                    position="top-left"
                    autoClose={2500}
                    hideProgressBar
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable
                    theme="light"
                    style={{ fontSize: '14px', width: '320px', top: '80px', left: '20px' }}
                    toastClassName="custom-toast"
                    limit={3}
                  />
                </SettingsProvider>
              </UserDataProvider>
            </CompanyThemeProvider>
          </CompanyConfigProvider>
        </LanguageProvider>
      </ClientPreferencesProvider>
    </AuthProvider>
  </BrandProvider>
);